import L from 'leaflet'
import React, { FC } from 'react'
import { useMap } from 'react-leaflet'

// Component to fit map bounds
export const MapBounds: FC<{ locations: [number, number][] }> = ({
  locations,
}) => {
  const map = useMap()

  React.useEffect(() => {
    if (locations.length > 0) {
      const bounds = L.latLngBounds(locations as [number, number][])
      map.fitBounds(bounds, { padding: [50, 50] })
    }
  }, [locations, map])

  return null
}
